import React, { useEffect, useState } from 'react';
import './MotivationStats.css';

import coinsImg from '../../imagesHome/coins.png';
import light from '../../imagesHome/light.png';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

function useCountUp(end, duration = 1000) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    let start = 0;
    const safeEnd = end || 0;
    const stepTime = Math.max(duration / (safeEnd || 1), 25);

    setValue(0);

    const interval = setInterval(() => {
      start += 1;
      if (start >= safeEnd) {
        setValue(safeEnd);
        clearInterval(interval);
      } else {
        setValue(start);
      }
    }, stepTime);

    return () => clearInterval(interval);
  }, [end, duration]);

  return value;
}

function MotivationStats({ coins, xp, correct, wrong }) {
  const stats = [
    {
      label: "Monede",
      value: useCountUp(coins || 0, 900),
      icon: <img src={coinsImg} alt="coins" className="stat-png-icon" />,
      class: "coins",
      color: "#ffcb5a"
    },
    {
      label: "XP Obținut",
      value: useCountUp(xp || 0, 700),
      icon: <img src={light} alt="xp" className="stat-png-icon" />,
      class: "xp",
      color: "#a87bff"
    },
    {
      label: "Quizuri Corecte",
      value: useCountUp(correct || 0, 900),
      icon: <FontAwesomeIcon icon={faCheckCircle} className="stat-fa-correct" />,
      class: "correct",
      color: "#00c853"
    },
    {
      label: "Quizuri Greșite",
      value: useCountUp(wrong || 0, 900),
      icon: <FontAwesomeIcon icon={faTimesCircle} className="stat-fa-wrong" />,
      class: "wrong",
      color: "#d50000"
    }
  ];

  return (
    <div className="stats-wrapper-bc">
      <div className="stats-vertical-bc">
        {stats.map((item, index) => (
          <div
            key={index}
            className={`stat-card-bc ${item.class}`}
            style={{ animationDelay: `${index * 0.35}s` }}
          >
            <div className="stat-row-top">
              <div className="stat-icon-bc">{item.icon}</div>
              <span className="stat-label-text">{item.label}</span>
              <span className="stat-value-bc">{item.value}</span>
            </div>

            <div className="progress-bar-wrapper">
              <div
                className="progress-bar-fill"
                style={{
                  width: `${item.value}%`,
                  backgroundColor: item.color,
                  animationDelay: `${index * 0.35 + 0.2}s`
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MotivationStats;
